import { tokens } from 'styling/tokens'
import { GLDonut, GLDonutHole, GLDonutValue, GLDonutSub } from '../GlobalView.styled'

export const MachineDonut = ({
  working,
  idle,
  label,
  notAvailable,
}: {
  working?: number
  idle?: number
  label: string
  notAvailable?: boolean
}) => {
  const total = (working || 0) + (idle || 0)
  const available = !notAvailable && total > 0
  const pct = available ? Math.round(((working || 0) / total) * 100) : 0
  const gradient = available
    ? `conic-gradient(${tokens.accent.base} 0% ${pct}%, ${tokens.surface.inset} ${pct}% 100%)`
    : `conic-gradient(${tokens.surface.inset} 0 100%)`

  return (
    <GLDonut $gradient={gradient}>
      <GLDonutHole>
        <GLDonutValue $muted={!available}>{available ? label : 'N/A'}</GLDonutValue>
        {!available && <GLDonutSub>Not Available</GLDonutSub>}
      </GLDonutHole>
    </GLDonut>
  )
}
